import { render, staticRenderFns } from "./TrSelect.vue?vue&type=template&id=5d07bc8c&scoped=true&"
import script from "./TrSelect.vue?vue&type=script&lang=js&"
export * from "./TrSelect.vue?vue&type=script&lang=js&"
import style0 from "./TrSelect.vue?vue&type=style&index=0&id=5d07bc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07bc8c",
  null
  
)

export default component.exports